import React, { useEffect, useState } from "react";
import ProducerNav from "../ProducerNav/ProducerNav";
import { useParams } from "react-router";
import config from "../../config/apiConfig";
import RingLoader from "react-spinners/RingLoader";
import negetive from "../../icons/negetive.png";
import positive from "../../icons/positive.png";
import neutral from "../../icons/neutral.png";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { ExpandMore, ArrowBack } from "@material-ui/icons";
import BuyDrawer from "./BuyDrawer/BuyDrawer";
import ChapterDetails from "./ChapterDetails/ChapterDetails";
import StoryCardSmall from "../StoryCardSmall/StoryCardSmall";

function BuyStory() {
    const [story, setStory] = useState();
    const [stories, setStories] = useState([]);
    const [chapters, setChapters] = useState([]);
    const [selected, setSelected] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [openDrawer, setOpenDrawer] = useState(false);

    const { id } = useParams();

    useEffect(() => {
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token"));
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        const promise1 = fetch(
            config.BASE_URL + "/v1/get/writingtool/story/" + id + "/info",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => setStory(res.data));
        const promise2 = fetch(
            config.BASE_URL + "/v1/get/writingtool/story/" + id + "/chapters",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => setChapters(res.data));

        setIsLoading(true);
        Promise.all([promise1, promise2]).finally(() => setIsLoading(false));
    }, []);

    useEffect(() => {
        if (!!story) {
            const requestOptions = {
                method: "POST",
                body: null,
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    session_token: Cookies.get("token") ?? "",
                    token: config.token,
                },
            };
            fetch(
                config.BASE_URL +
                    "/v2/api/story/alsoLike?page=1&pageSize=50&orderBy=2&genre=" +
                    story.genres +
                    "&storyId=" +
                    id,
                requestOptions
            )
                .then((res) => res.json())
                .then((res) => setStories(res));
        }
    }, [story]);

    function handleShowAns(e, id) {
        const ele = document.getElementById(id);
        if (ele.style.display === "none") {
            ele.style.display = "block";
            document.getElementById(`icon ${id}`).innerHTML =
                '<svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"></path></svg>';
        } else {
            ele.style.display = "none";
            document.getElementById(`icon ${id}`).innerHTML =
                '<svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>';
        }
    }

    function getScoreText(score) {
        switch (score) {
            case 0:
                return <p style={{ color: "green" }}>Low</p>;
            case 1:
                return <p style={{ color: "orange" }}>Medium</p>;
            case 2:
                return <p style={{ color: "red" }}>High</p>;
        }
    }

    function getSentimentWidget(sentiment) {
        switch (sentiment) {
            case "neutral":
                return (
                    <React.Fragment>
                        <img
                            style={{ marginRight: 8 }}
                            src={neutral}
                            alt="neutral img"
                        />
                        <span>Neutral</span>
                    </React.Fragment>
                );
            case "positive":
                return (
                    <React.Fragment>
                        <img
                            style={{ marginRight: 8 }}
                            src={positive}
                            alt="positive img"
                        />
                        <span style={{ color: "green" }}>Positive</span>
                    </React.Fragment>
                );
            case "negative":
                return (
                    <React.Fragment>
                        <img
                            style={{ marginRight: 8 }}
                            src={negetive}
                            alt="negetive img"
                        />
                        <span style={{ color: "red" }}>Negative</span>
                    </React.Fragment>
                );
        }
    }

    if (isLoading || story === undefined) {
        return (
            <div style={{ textAlign: "center", backgroundColor: "black" }}>
                <ProducerNav />
                <RingLoader color="black" loading={isLoading} />
            </div>
        );
    }

    return (
        <div className="story__container">
            <ProducerNav />
            <BuyDrawer open={openDrawer} onClose={() => setOpenDrawer(false)} />
            <div className="header__nav">
                <div className="header__left">
                    <Link className="header__p" to="/">
                        <ArrowBack fontSize="small" />
                        Go back to Discover
                    </Link>
                </div>
                <div className="header__right">
                    <button className="white__btn" onClick={(e) => {}}>
                        + Shortlist story
                    </button>

                    <button
                        className={"head__btn"}
                        onClick={() => setOpenDrawer(true)}
                    >
                        Buy for ₹2,999
                    </button>
                </div>
            </div>
            <div className="main__content chapter-details">
                {chapters.length > 0 ? (
                    <ChapterDetails
                        chapter={chapters[selected]}
                        storyId={id}
                        chapters={chapters}
                        goToPrevious={() => setSelected(selected - 1)}
                        goToNext={() => setSelected(selected + 1)}
                    />
                ) : null}
                <div className="story__info">
                    <div className="score">
                        <div
                            className="load"
                            style={{
                                borderRadius: "15px 0 0 15px",
                                zIndex: "1",
                                height: "48px",
                                position: "absolute",
                                background: "#81b524",
                                top: "0",
                                bottom: "0",
                                left: "0",
                                width: `${0 * 100}%`,
                                opacity: "0.3",
                            }}
                        ></div>
                        <h4>
                            Story Score: {(0 * 100).toString().substr(0, 2)}%
                        </h4>
                    </div>
                    <div
                        className="social"
                        style={{ alignItems: "center", padding: "0 20px" }}
                    >
                        <div>
                            <h4
                                style={{
                                    fontSize: "16px",
                                    margin: "0px !important",
                                    color: "#4a4a4a",
                                }}
                            >
                                Sentiment
                            </h4>
                        </div>

                        <div>
                            <p
                                style={{
                                    margin: "0",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                {getSentimentWidget(1)}
                            </p>
                        </div>
                    </div>
                    <div className="q__card" style={{ padding: 24 }}>
                        <div>
                            <div>
                                <h4
                                    style={{
                                        fontSize: "16px",
                                        margin: "0px !important",
                                        color: "#4a4a4a",
                                    }}
                                >
                                    Scores
                                </h4>
                            </div>

                            <div></div>
                        </div>
                        <div>
                            <div className="hor__line"></div>
                            <div className="scores_section">
                                <p>Relevancy</p>
                                {getScoreText(1)}
                            </div>
                            <div className="scores_section">
                                <p>Uniqueness</p>
                                {getScoreText(2)}
                            </div>
                            <div className="scores_section">
                                <p>Virality</p>
                                {getScoreText(0)}
                            </div>
                            <div className="scores_section">
                                <p>Sustenance</p>
                                {getScoreText(1)}
                            </div>
                        </div>
                    </div>

                    {[].length > 0 && (
                        <div className="q__card">
                            <div
                                className="q__ques"
                                onClick={(e) => handleShowAns(e, "st")}
                            >
                                <h4
                                    style={{
                                        fontSize: "16px",
                                        margin: "0px !important",
                                        color: "#4a4a4a",
                                    }}
                                >
                                    Genre
                                </h4>
                                <div id={`icon st`}>
                                    <ExpandMore />
                                </div>
                            </div>
                            <div
                                className="q__ans"
                                style={{ display: "none" }}
                                id="st"
                            >
                                <div className="hor__line"></div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {[].map((st) => (
                                        <p
                                            onClick={(e) => {
                                                e.preventDefault();
                                                const win = window.open(
                                                    `/writer?article_tag=${st}`,
                                                    "_blank"
                                                );
                                                win.focus();
                                            }}
                                            className="tag"
                                        >
                                            {st}
                                        </p>
                                    ))}
                                    {[].map((ak) => (
                                        <p
                                            onClick={(e) => {
                                                e.preventDefault();
                                                const win = window.open(
                                                    `/writer?article_keyword=${ak}`,
                                                    "_blank"
                                                );
                                                win.focus();
                                            }}
                                            className="tag"
                                        >
                                            {ak}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {stories.length != 0 && (
                <div className="similar__container">
                    <div
                        style={{
                            marginTop: 64,
                            borderBottom: "solid 1px rgba(112, 112, 112, 0.2)",
                        }}
                    >
                        <h4
                            style={{
                                fontSize: "20px",
                                marginBottom: "20px !important",
                                padding: "0 0 20px 0",
                            }}
                        >
                            Similar Stories
                        </h4>
                    </div>
                    <div className="horiz__list">
                        {stories.map((s, index) => {
                            return (
                                <div
                                    key={s.storyId}
                                    className="story__title story__title__small"
                                >
                                    <StoryCardSmall
                                        style={{ marginRight: 24 }}
                                        onRemove={() =>
                                            setStories(
                                                stories.filter((t) => t !== s)
                                            )
                                        }
                                        {...s}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}

export default BuyStory;
